import { jsx } from "react/jsx-runtime";
import { TextField } from "@mui/material";
import { useCallback, useLayoutEffect, useRef } from "react";
import { getInputProps } from "../utils/getInputProps.js";
const defaultUserInput = () => true;
function onKeyDown(e) {
  if (e.key === "Backspace") e.stopPropagation();
}
function useRenderInput(props, filterOptions) {
  const {
    multiSelectState: {
      props: {
        error = false,
        items,
        label,
        inputMode = "normal",
        textFieldProps,
        placeholder,
        filterInput = defaultUserInput,
        required,
        startAdornment
      },
      searchState: [, setSearchValue]
    },
    setVisibleOptions
  } = props;
  const rInfo = useRef({
    items,
    filterInput,
    filterOptions,
    setSearchValue,
    setVisibleOptions
  });
  useLayoutEffect(
    () => void (rInfo.current = {
      items,
      filterInput,
      filterOptions,
      setSearchValue,
      setVisibleOptions
    }),
    [items, filterInput, filterOptions, setSearchValue, setVisibleOptions]
  );
  const handleOnChange = useCallback((event) => {
    const newInputValue = event.target.value;
    const acceptInput = rInfo.current.filterInput(newInputValue);
    if (!acceptInput) return;
    rInfo.current.setSearchValue(newInputValue);
  }, []);
  return useCallback(
    (params) => {
      const { InputProps, ...restTextFieldProps } = textFieldProps ?? {};
      return /* @__PURE__ */ jsx(
        TextField,
        {
          "data-testid": "multiselect-input",
          ...params,
          error,
          fullWidth: true,
          label,
          InputProps: getInputProps(params, InputProps, startAdornment),
          onChange: handleOnChange,
          onKeyDown: inputMode === "summary" ? onKeyDown : void 0,
          placeholder,
          required,
          ...restTextFieldProps
        }
      );
    },
    [label, textFieldProps, placeholder, required, inputMode, handleOnChange, startAdornment, error]
  );
}
export {
  useRenderInput
};
//# sourceMappingURL=useRenderInput.js.map
